'use client'

import '@shopify/polaris/build/esm/styles.css'
import { AppProvider } from '@shopify/polaris'
import enTranslations from '@shopify/polaris/locales/en.json'
import { PolarisLink } from '@/components/PolarisLink'

export default function StaticLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <AppProvider i18n={enTranslations} linkComponent={PolarisLink as any}>
      {children}
    </AppProvider>
  )
}
